import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardText = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33594 3.33337C4.67704 3.33388 4.33166 3.34225 4.06395 3.47866C3.81307 3.60649 3.60909 3.81046 3.48126 4.06135C3.33594 4.34656 3.33594 4.71993 3.33594 5.46667V11.8667C3.33594 12.6134 3.33594 12.9868 3.48126 13.272C3.60909 13.5229 3.81307 13.7268 4.06395 13.8547C4.34917 14 4.72253 14 5.46927 14H10.5359C11.2827 14 11.656 14 11.9413 13.8547C12.1921 13.7268 12.3961 13.5229 12.5239 13.272C12.6693 12.9868 12.6693 12.6134 12.6693 11.8667V5.46667C12.6693 4.71993 12.6693 4.34656 12.5239 4.06135C12.3961 3.81046 12.1921 3.60649 11.9413 3.47866C11.6735 3.34225 11.3282 3.33388 10.6693 3.33337M5.33594 3.33337V4.66667H10.6693V3.33337M5.33594 3.33337V3.13807C5.33594 2.83624 5.45584 2.54676 5.66927 2.33333C5.8827 2.1199 6.17217 2 6.47401 2H9.5312C9.83303 2 10.1225 2.1199 10.3359 2.33333C10.5494 2.54676 10.6693 2.83624 10.6693 3.13807V3.33337M8.0026 10H6.0026M10.0026 7.33333H6.0026",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClipboardText;
